const headers = [
  // {
  //   label: "เลขร้องทุกข์",
  //   field: "Code",
  // },
  {
    label: "เลขเอกสาร",
    field: "docCode",
  },
  {
    label: "ประเภทเอกสาร",
    field: "file",
  },
  {
    label: "สถานะ",
    field: "status",
  },
  // {
  //   label: "วันที่ดำเนินการ",
  //   field: "Complain_Date",
  // },
  // {
  //   label: "เจ้าหน้าที่",
  //   field: "name",
  // },
  {
    label: "Action",
    field: "action",
  },
];

export default headers;
